var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtLink',{attrs:{"to":_vm.link}},[_c('div',{staticClass:"mobile-page-header"},[_c('div',{staticClass:"motec-section"},[_c('div',{staticClass:"mobile-title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }